// store/store.js
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer.js'
import { 
  errorMiddleware, 
  apiMiddleware,
  listenerMiddleware,
  notificationMiddleware
} from './middleware.js'
import { keycloakMiddleware } from '../features/Auth/store/authMiddleware.js'
import  config  from '../constants/config.js'
import '../features/MediaControls/store/mediaControlListeners.js';
import './messagesSlice/messagesMiddleware.js'
import '../features/ControlPanel/store/settings/settingsMiddleware.js';
import '../features/Notifications/store/notificationsMiddleware.js';
import '../features/Map/store/MapDisplayMiddleware.js';
import '../features/MediaControls/store/raisedHandsMiddleware.js';
import '../features/ProductivitySession/store/ProductivitySessionMiddleware.js';
import '../features/Whiteboard/store/whiteboardMiddleware.js';
import '../features/Conference/store/ConferenceMiddleware.js'
const store = configureStore({
  reducer: rootReducer,
  devTools: config.LAUNCH_MODE === 'dev',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    })
    .prepend(listenerMiddleware.middleware, 
      
    )
    .concat(notificationMiddleware.middleware, errorMiddleware, apiMiddleware, keycloakMiddleware),
})

// Hot reload configuration
if (config.LAUNCH_MODE === 'dev' && module.hot) {
  module.hot.accept('./rootReducer.js', () => {
    const nextRootReducer = require('./rootReducer.js').default;
    store.replaceReducer(nextRootReducer);
  });
}

export default store